import Layout from '@layout/Index'

export const task = [
  {
    path: '/task',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "task-table" */ './pages/TaskTable.vue'),
        name: '任务列表',
        meta: {
          title: '任务列表',
        },
      },
      {
        path: 'archived/table',
        component: () => import(/* webpackChunkName: "task-table" */ './pages/TaskArchivedTable.vue'),
        name: '任务列表(归档)',
        meta: {
          title: '任务列表(归档)',
        },
      },
      {
        path: 'md/table/:id',
        component: () => import(/* webpackChunkName: "MidanTaskTable" */ './pages/MidanTaskTable.vue'),
        name: '米单任务列表',
        meta: {
          title: '米单任务列表',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "task-form" */ './pages/TaskForm.vue'),
        name: '添加任务',
        meta: {
          title: '添加任务',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "task-form" */ './pages/TaskForm.vue'),
        name: '修改任务',
        meta: {
          title: '修改任务',
        },
      },
      {
        path: 'detail/:taskid',
        component: () => import(/* webpackChunkName: "task-detail" */ './pages/TaskDetail.vue'),
        name: '任务详情',
        meta: {
          title: '任务详情',
        },
      },
      {
        path: 'batch/table',
        component: () => import(/* webpackChunkName: "task-batch" */ './pages/TaskUploadTable.vue'),
        name: '批量任务',
        meta: {
          title: '批量任务',
        },
      },
      {
        path: 'preview-app/:taskid',
        component: () => import(/* webpackChunkName: "task-preview-app" */ './pages/TaskPreviewApp.vue'),
        name: '任务预览',
        meta: {
          title: '任务预览',
        },
      },
      {
        path: 'nearby-users/:taskid',
        component: () => import(/* webpackChunkName: "task-nearby-users" */ './pages/TaskNearbyUsers.vue'),
        name: '周边零工',
        meta: {
          title: '周边零工',
        },
      },
      {
        path: 'map',
        component: () => import(/* webpackChunkName: "task-table" */ './pages/TaskMap.vue'),
        name: '任务地图看板',
        meta: {
          title: '任务地图看板',
        },
      },
      {
        path: 'map-covered-users/:taskid',
        component: () => import(/* webpackChunkName: "map-covered-users" */ './pages/TaskMapUser.vue'),
        name: '周边零工-历史工单覆盖',
        meta: {
          title: '周边零工-历史工单覆盖',
        },
      },
      {
        path: 'map-idcard-users/:taskid',
        component: () => import(/* webpackChunkName: "map-idcard-users" */ './pages/TaskMapIdCardUser.vue'),
        name: '周边零工-身份证覆盖',
        meta: {
          title: '周边零工-身份证覆盖',
        },
      },
      {
        path: 'review-task-table',
        component: () => import(/* webpackChunkName: "recheck-task-table" */ './pages/ReviewTaskTable.vue'),
        name: '复核任务列表',
        meta: {
          title: '复核任务列表',
          pageType: 'review-order-task',
        },
      },
      {
        path: 'review-plan/table',
        component: () => import(/* webpackChunkName: "review-plan-table" */ './pages/ReviewPlanTable.vue'),
        name: '复核目标管理',
        meta: {
          title: '复核目标配置',
        },
      },
      {
        path: 'review-plan/form',
        component: () => import(/* webpackChunkName: "review-plan-form-create" */ './pages/ReviewPlanFormPage.vue'),
        name: '添加复核目标',
        meta: {
          title: '添加复核目标',
        },
      },
      {
        path: 'review-plan/form/:id',
        component: () => import(/* webpackChunkName: "review-plan-form-update" */ './pages/ReviewPlanFormPage.vue'),
        name: '修改复核目标',
        meta: {
          title: '修改复核目标',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/task/task.route.js